module.exports = __webpack_public_path__ + "img/swift-gls-rojo-vanadio.d7d09839.png";